// @flow
import type { DateRange } from "data/units/date/types"
import { repeat } from "ramda"
import type { ProductVariantAvailableAffiliate } from "data/product/types"
import { getDaysApart } from "data/units/date/helpers"
import type { OriginalReservation } from "data/reservations/types"

export const getPricePerDayArray = (
  dates: ?DateRange,
  a: ProductVariantAvailableAffiliate,
  originalReservation?: ?OriginalReservation,
): number[] => {
  if (!dates) return []

  const pricing = a.pricing

  const daysApart = getDaysApart(dates.endDate, dates.startDate) + 1
  const daysWithinPricing = pricing.slice(0, daysApart)
  const daysForLastPrice = repeat(
    pricing[pricing.length - 1],
    Math.max(0, daysApart - pricing.length),
  )
  const priceArray = daysWithinPricing.concat(daysForLastPrice)

  if (originalReservation) {
    const extendedDaysApart =
      getDaysApart(originalReservation.endDate, dates.startDate) + 1
    return priceArray.slice(extendedDaysApart)
  }

  return priceArray
}



// WEBPACK FOOTER //
// ./src/data/units/money/helpers.js